import NavBar from "@components/NavBar/NavBar.component";
import RequestFeature from "@components/RequestFeature/RequestFeature.component";
import Sidebar from "@components/Sidebar/Sidebar.component";
import { Box, useMediaQuery } from "@mui/material"
import { ReactNode, useEffect, useState } from "react";
import theme from "theme";

interface PartnerLayoutProps {
    children: ReactNode;
}

const PartnerLayout = ({children}: PartnerLayoutProps) => {

    const [showSidebar, setShowSidebar] = useState(false);
    const [showRequestFeature, setShowRequestFeature] = useState(false)

    const handleSidebar = () => {
        setShowSidebar(prev => !prev);
    }

    function handleRequestFeature(){
        setShowRequestFeature(true)
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh"}}>
            <NavBar burgerMenuClick={handleSidebar}/>

            <Box sx={{ display: "flex", flexGrow: 1, position: 'relative',  }}>
                <Sidebar handleSidebar={handleSidebar} showSidebar={showSidebar} handleRequestFeature={handleRequestFeature}/>

                <RequestFeature open={showRequestFeature} onClose={() => setShowRequestFeature(false)} />

                <Box sx={{ flexGrow: 1, backgroundColor: "#f9f9f9", minHeight: "100%", overflowY: 'hidden', padding: '20px 25px' }}>
                    {children}
                </Box>
            </Box>
        </Box>
    );
}

export default PartnerLayout